import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { openIntercom } from 'entities/Intercom'
import styles from './styles.module.scss'

type ICommonErrorBannerProps = {
  errorMessage?: string | null
  title?: string
}

export const CommonErrorBanner = observer(
  ({
    errorMessage,
    title = 'Your business profile application was rejected.',
  }: ICommonErrorBannerProps) => {
    if (!errorMessage) return null

    return (
      <Alert
        item={{
          type: 'error',
          title,
          desc: errorMessage,
        }}
        actions={[
          {
            variant: 'button',
            type: 'primary',
            text: 'Learn more',
            onClick: () => {
              openIntercom()
            },
          },
        ]}
        marginTop={20}
        className={styles.errorBanner}
      />
    )
  }
)
